import Communication from "../../communication"
import config from "../../config"

const TokensService = { 
    loadDashboards(dispatch, data) {
        dispatch({
            type: 'LOAD_TOKENS',
            payload: null
        })
        Communication.getMethod(
            config.endPoints.tokens,
            {}
        ).then(dashboards => { 
                dispatch({
                    type: 'GET_TOKENS',
                    payload: dashboards
                })
        }).catch(() => {
            dispatch({
                type: 'ERROR_TOKENS',
                payload: null
            })
        }).finally(() => {})
    },  
}
export default TokensService;